import Swal from 'sweetalert2'
import PageLoadedQueue
    from "../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";

export function Announcements() {
    const userAnnouncement = document.querySelector('template[id="user-announcement"]') as HTMLTemplateElement;

    if (!userAnnouncement) return;

    Swal.fire({
        titleText: userAnnouncement.dataset.announcementTitle,
        html: userAnnouncement.content.querySelector('#content').innerHTML,
        showCloseButton: true,
        allowEscapeKey: true,
        showConfirmButton: false,
        customClass: {
            htmlContainer: 'text-start'
        },
        didClose: () => {
            const idElements = userAnnouncement.content.querySelectorAll('[data-announcement-id]') as NodeListOf<HTMLElement>;
            let ids = [];

            idElements.forEach((element) => {
                ids.push(element.dataset.announcementId);
            });

            fetch('/api/announcements/mark-as-read', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    announcements: ids,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok.');
                    }
                })
                .catch((error) => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
            }
    });
}

PageLoadedQueue.addFunction(Announcements);
